<template>
  <Layout :tituloPagina="'Inicio ISP'">
    <div class="row">
      <div class="col-xxl-3 col-lg-3 col-sm-6" v-if="tienePermiso('cmpTicketSoporte','componente') && widgets.WSoportes">
        <w-soportes></w-soportes>
      </div>
      <div class="col-xxl-3 col-lg-3 col-sm-6" v-if="tienePermiso('cmpFacturas','componente') && widgets.WFacturas">
        <w-facturas></w-facturas>
      </div>
      <div class="col-xxl-3 col-lg-3 col-sm-6" v-if="tienePermiso('cmpCpes','componente') && widgets.WCpes">
        <w-cpes></w-cpes>
      </div>
      <div class="col-xxl-3 col-lg-3 col-sm-6" v-if="tienePermiso('cmpClientes','componente') && widgets.WClientes">
        <w-clientes></w-clientes>
      </div>
      <div class="col-xxl-3 col-lg-3 col-sm-6" v-if="tienePermiso('cmpRouter','componente') && widgets.WRouters">
        <w-routers></w-routers>
      </div>
      <div class="col-xxl-3 col-lg-3 col-sm-6" v-if="tienePermiso('cmpInstalaciones','componente') && widgets.WInstalaciones">
        <w-instalaciones></w-instalaciones>
      </div>
      <div class="col-xxl-3 col-lg-3 col-sm-6" v-if="tienePermiso('cmpEventosCalendario','componente') && widgets.WEventosCalendario">
        <w-eventos-calendario></w-eventos-calendario>
      </div>
      <div class="col-xxl-3 col-lg-3 col-sm-6" v-if="tienePermiso('cmpDhs','componente') && widgets.WDispositivosHogar">
        <w-dispositivos-hogar></w-dispositivos-hogar>
      </div>
    </div>

    <div class="row">
      <div class="col-xxl-12" v-if="tienePermiso('cmpCrecimientoMensual','componente') && widgets.WCrecimiento">
        <w-crecimiento></w-crecimiento>
      </div>
    </div>

    <div class="row">
      <div class="col-xxl-6" v-if="tienePermiso('cmpNuevosClientes','componente') && widgets.WClientesNuevosPorMes">
        <w-clientes-nuevos-por-mes></w-clientes-nuevos-por-mes>
      </div>
      <div class="col-xxl-6" v-if="tienePermiso('cmpCancelacionesPorMes','componente') && widgets.WCancelacion">
        <w-cancelacion></w-cancelacion>
      </div>
    </div>

    <div class="row">
      <div class="col-xxl-6 mb-1">
        <!-- <router-link :to="{ name: 'soporteParaArgusBlack' }" class="btn btn-secondary text-truncate w-100" title="¿Tienes dudas o requieres soporte?">
          <i class="mdi mdi-help-circle-outline font-size-16 align-middle me-1"></i>
          Soporte para ArgusBlack
        </router-link> -->
        <a 
          href="https://wa.me/5215662202397" 
          class="btn btn-secondary text-truncate w-100" 
          title="¿Tienes dudas o requieres soporte?"
          target="_blank" rel="noopener noreferrer"
        >
          <i class="mdi mdi-help-circle-outline font-size-16 align-middle me-1"></i>
          Soporte para ArgusBlack
        </a>
      </div>

      <div class="col-xxl-6">
        <widgets-visibles 
          ref="widgetsIsp"
          @actualizar-widgets="cargarAjustesWidgets()"
        ></widgets-visibles>
      </div>
    </div>
    <br>
  </Layout>
</template>

<script>
import UsuarioSrv from '@/services/UsuarioSrv.js'
import Layout from "@/views/layouts/main.vue"

import WSoportes from './WSoportes.vue'
import WFacturas from './WFacturas.vue'
import WCpes from './WCpes.vue'
import WClientes from './WClientes.vue'
import WCrecimiento from './WCrecimiento.vue'
import WClientesNuevosPorMes from './WClientesNuevosPorMes.vue'
import WCancelacion from './WCancelacion.vue'
import WRouters from './WRouters.vue'
import WInstalaciones from './WInstalaciones.vue'
import WEventosCalendario from './WEventosCalendario.vue'
import WDispositivosHogar from './WDispositivosHogar.vue'
import WidgetsVisibles from './WidgetsVisibles.vue'

import { todoGetters } from "@/state/helpers"

export default {
  name: 'Inicio',
  components: {
    Layout,
    WSoportes,
    WFacturas,
    WCpes,
    WClientes,
    WCrecimiento,
    WClientesNuevosPorMes,
    WCancelacion,
    WRouters,
    WInstalaciones,
    WEventosCalendario,
    WDispositivosHogar,
    WidgetsVisibles
  },
  data() {
    return {
      widgets: {
        WSoportes: false,
        WFacturas: false,
        WCpes: false,
        WClientes: false,
        WCrecimiento: false,
        WClientesNuevosPorMes: false,
        WCancelacion: false,
        WRouters: false,
        WInstalaciones: false,
        WEventosCalendario: false,
        WDispositivosHogar: false,
      }
    }
  },
  created: function() {
    var self = this

    self.cargarAjustesWidgets()
  },
  computed: { ...todoGetters },
  methods: {    
    cargarAjustesWidgets: function() {
      var self = this
      var widgets = [
        'WSoportes','WFacturas','WCpes','WClientes','WCrecimiento',
        'WClientesNuevosPorMes','WCancelacion','WRouters','WInstalaciones',
        'WEventosCalendario','WDispositivosHogar'
      ]

      UsuarioSrv.ajustesJSON(widgets).then(response => {
        let ajustes = response.data

        // Convertimos y asignamos cada valor al objeto widgets
        for (const key in ajustes) {
          if (self.widgets.hasOwnProperty(key)) {
            self.widgets[key] = ajustes[key] === '1'; // Convertimos a booleano
          }
        }
      }).catch(error => {
        let mensaje 
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar los ajustes del widgets'
        }
        console.log(error)
        iu.msg.error(mensaje)
      })
    }
  }
}
</script>